import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from './assets/download.svg';
import InstaIcon from './assets/icon/social/instagram_c.png';
import FacebookIcon from './assets/icon/social/facebook_c.png';
import PinterestIcon from './assets/icon/social/pinterest_c.png';
import TwitterIcon from './assets/icon/social/twitter_c.png';
import YoutubeIcon from './assets/icon/social/youtube_c.png';
import WhatsappIcon from './assets/icon/social/whatsapp_c.png';
import RazorpayIcon from './assets/logo/razorpay_w.svg';
import VisaIcon from './assets/logo/visa.svg';
import MastercardIcon from './assets/logo/mastercard.svg';
import RupayIcon from './assets/logo/rupay.svg';
import UpiIcon from './assets/logo/upi.svg';
import PhonePeIcon from './assets/logo/phonepe.svg';
import GooglePayIcon from './assets/logo/google_pay.svg';

export default function Foot() {
  return (
    <div className="new-footer-wrapper w-full bg-[#050608] flex flex-col justify-end font-body">
      <style>{`
        .new-footer-wrapper button {
          background: transparent;
          border: none;
          box-shadow: none;
          padding: 0;
        }

        .new-footer-wrapper,
        .new-footer-wrapper footer {
          background-color: #050608 !important;
        }

        .new-footer-wrapper input {
          box-shadow: none !important;
        }

        .new-footer-wrapper input:focus {
          outline: none !important;
          box-shadow: none !important;
          border-color: #D4AF37 !important;
        }

        .newsletter-input {
          background-color: #F2F2F2 !important;
          color: #000 !important;
          border: none !important;
        }

        .newsletter-button {
          background-color: #D4AF37 !important;
          color: #000 !important;
          border: none !important;
          padding-left: 2.5rem !important;
          padding-right: 2.5rem !important;
          min-width: 140px;
        }

        .newsletter-button:hover {
          background-color: #C5A028 !important;
        }

        .social-icon-img {
          filter: none;
        }

        .animate-marquee {
          display: inline-flex;
          animation: marquee 18s linear infinite;
        }

        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .underline-bar {
          background: #D4AF37;
          transform-origin: center;
          transform: scaleX(0);
          animation: underlinePulse 3.8s ease-in-out infinite;
        }

        @keyframes underlinePulse {
          0% { transform: scaleX(0); opacity: 0; }
          20% { transform: scaleX(1); opacity: 1; }
          80% { transform: scaleX(1); opacity: 1; }
          100% { transform: scaleX(0); opacity: 0; }
        }
      `}</style>
      <Footer />
    </div>
  );
}

function Footer() {
  const logoRef = useRef(null);

  const socialLinks = [
    { src: InstaIcon, alt: 'Instagram', href: 'https://www.instagram.com/maviinci_in/' },
    { src: FacebookIcon, alt: 'Facebook', href: 'https://www.facebook.com/share/15DXLNZj4E/' },
    { src: PinterestIcon, alt: 'Pinterest', href: 'https://in.pinterest.com/maviincifashion/' },
    { src: TwitterIcon, alt: 'X', href: 'https://x.com/maviincifashion?t=3Hy6jKr1NxuBUemXqMeYUA&s=08' },
    { src: YoutubeIcon, alt: 'YouTube', href: 'https://www.youtube.com/@maviincifashion' },
    { src: WhatsappIcon, alt: 'WhatsApp', href: 'https://wa.me/918871081395' },
  ];

  const footerSections = [
    {
      title: 'Custom Tailor',
      items: [
        { label: 'Suit', href: '/custom/suit/select_cloth/personalize' },
        { label: 'Formal Wear', href: '/custom/shirt/select_cloth/personalize' },
        { label: 'Blazer', href: '/custom/blazer/select_cloth/personalize' },
        { label: 'Kurta', href: '/custom/kurta/select_cloth/personalize' },
        { label: 'Uniform', href: '/custom/uniform/select_cloth/personalize' },
        { label: 'Shirt', href: '/custom/shirt/select_cloth/personalize' },
        { label: 'Pant', href: '/custom/pant/select_cloth/personalize' },
        { label: 'Jubba', href: '/custom/jubba/select_cloth/personalize' },
        { label: 'T-Shirt', href: '/custom/tshirt/select_cloth/personalize' },
      ],
    },
    {
      title: 'Quick Links',
      items: [
        { label: 'Designer / Exclusive', href: '/products' },
        { label: 'Kurta Collections', href: '/products/kurta' },
        { label: 'Suit Collections', href: '/products/suit' },
        { label: 'Formal Wear', href: '/products/formal' },
        { label: 'Exhibition', href: '/appointment' },
        { label: 'About Us', href: '/about-us' },
      ],
    },
    {
      title: 'Customer Service',
      items: [
        { label: 'Terms and Conditions', href: '/terms' },
        { label: 'Privacy Policy', href: '/terms' },
        { label: 'Contact Us', href: '/contact' },
        { label: 'Get Quotation', href: '/quotation' },
      ],
    },
  ];

  const paymentIcons = [
    { src: RazorpayIcon, alt: 'Razorpay', href: 'https://razorpay.com/' },
    { src: UpiIcon, alt: 'UPI', href: 'https://www.npci.org.in/what-we-do/upi/product-overview' },
    { src: PhonePeIcon, alt: 'PhonePe', href: 'https://www.phonepe.com/' },
    { src: GooglePayIcon, alt: 'Google Pay', href: 'https://pay.google.com/' },
    { src: VisaIcon, alt: 'Visa', href: 'https://www.visa.co.in/' },
    { src: MastercardIcon, alt: 'Mastercard', href: 'https://www.mastercard.co.in/' },
    { src: RupayIcon, alt: 'RuPay', href: 'https://www.rupay.co.in/' },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        window.dispatchEvent(
          new CustomEvent('footer-logo-visibility', {
            detail: {
              visible: entry.isIntersecting,
              ratio: entry.intersectionRatio,
            },
          })
        );
      },
      {
        threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
        rootMargin: '0px',
      }
    );

    if (logoRef.current) {
      observer.observe(logoRef.current);
    }

    return () => {
      if (logoRef.current) {
        observer.unobserve(logoRef.current);
      }
    };
  }, []);

  return (
    <footer className="bg-[#050608] text-slate-100 w-full">
      <div className="mx-auto max-w-[100%] xl:max-w-[100%] px-[10px] xl:px-[70px] py-12">
        <div className="border-b-2 border-slate-400 py-[25px] mb-10 flex flex-col lg:flex-row lg:justify-between lg:items-center gap-6">
          <div className="text-[clamp(1rem,1.2vw,1.5rem)] uppercase tracking-[0.25em] text-white font-medium">Sign up for our newsletter</div>
          <div className="w-full lg:w-auto">
            <div className="flex flex-row w-full max-w-full lg:w-[clamp(500px,30vw,800px)] h-[clamp(50px,4vw,80px)] gap-0">
              <input
                type="email"
                placeholder="Your email"
                className="newsletter-input flex-grow px-4 text-[clamp(1rem,1.2vw,1.5rem)] placeholder:text-gray-500 focus:outline-none h-full rounded-none min-w-0 m-0 border-0 ring-0"
              />
              <button className="newsletter-button font-bold uppercase tracking-widest h-full whitespace-nowrap text-[clamp(0.875rem,1vw,1.25rem)] rounded-none m-0 border-0 ring-0">
                Sign Up
              </button>
            </div>
          </div>
        </div>

        <style>{`
          @media (max-width: 768px) {
            .newsletter-button {
              padding-left: 1rem !important;
              padding-right: 1rem !important;
              min-width: auto !important;
              font-size: 0.75rem !important;
              margin-left: 0 !important;
            }

            .newsletter-input {
              margin-right: 0 !important;
            }
          }
        `}</style>

        <div className="mb-16 flex flex-col md:flex-row justify-between items-start">
          <h2 className="text-[clamp(2.5rem,4vw,6rem)] font-heading font-medium text-slate-100 m-0 leading-tight max-w-[clamp(48rem,50vw,70rem)]">
            THE TIME IS <span className="font-bold text-white">NOW.</span>
            <br />
            <span className="text-white">THE FIT IS MAVIINCI.</span>
          </h2>
          <div className="hidden md:block"></div>
        </div>

        <div className="mt-12 grid gap-2 md:gap-8 text-sm grid-cols-1 md:grid-cols-2 lg:grid-cols-4">
          {footerSections.map((section) => (
            <FooterSection key={section.title} title={section.title}>
              <ul className="space-y-2 text-[clamp(0.875rem,1vw,1.25rem)] !list-none !p-0 !m-0">
                {section.items.map((item) => (
                  <li key={item.href} className="text-slate-300 transition-colors hover:text-[#D4AF37]">
                    <a href={item.href} className="text-slate-300 hover:text-[#D4AF37] transition-colors" style={{ textDecoration: 'none' }}>
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </FooterSection>
          ))}

          <FooterSection title="Blue Pearl Industries">
            <div className="flex flex-col h-full justify-between">
              <div>
                <p className="text-slate-400 text-[clamp(0.875rem,1vw,1.25rem)] mb-2">Shanti Nagar Bhilai-3, Dist-Durg, <br/>Chhattisgarh 490021</p>
                <a
                  href="mailto:connect@bluepearlindustries.com"
                  className="text-[clamp(0.875rem,1vw,1.25rem)] leading-snug break-all text-slate-100 hover:text-[#D4AF37] transition-colors block mb-1"
                >
                  connect@bluepearlindustries.com
                </a>
                <p className="text-slate-400 text-[clamp(0.875rem,1vw,1.25rem)]">+91-8871081395</p>
              </div>
            </div>
          </FooterSection>
        </div>

        {/* New Row: Social and Payment Icons */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 border-t border-white/10 pt-8">
            {/* Column 1: Social Icons */}
            <div className="flex flex-col items-center md:items-start">
                 <p className="text-[clamp(0.75rem,0.9vw,1rem)] uppercase tracking-[0.25em] text-white mb-4">Follow Us</p>
                 <div className="flex gap-3 flex-wrap justify-center md:justify-start">
                      {socialLinks.map((item) => (
                        <a
                          key={item.href}
                          href={item.href}
                          target="_blank"
                          rel="noreferrer"
                          className="w-[clamp(2.5rem,3vw,4rem)] h-[clamp(2.5rem,3vw,4rem)] bg-white rounded-full flex items-center justify-center hover:bg-[#D4AF37] transition-colors group"
                        >
                          <img src={item.src} alt={item.alt} className="social-icon-img w-[clamp(1.25rem,1.5vw,2rem)] h-[clamp(1.25rem,1.5vw,2rem)] opacity-80 group-hover:opacity-100" />
                        </a>
                      ))}
                 </div>
            </div>
            
            {/* Column 2: Payment Icons */}
            <div className="flex flex-col items-center md:items-end">
                 <p className="text-[clamp(0.75rem,0.9vw,1rem)] uppercase tracking-[0.25em] text-white mb-4">We Accept</p>
                 <div className="flex gap-4 flex-wrap justify-center md:justify-end">
                      {paymentIcons.map((item) => (
                        <a key={item.alt} href={item.href} target="_blank" rel="noreferrer" className="inline-flex items-center">
                          <img src={item.src} alt={item.alt} className="h-[clamp(1.5rem,2vw,3rem)] w-auto opacity-90" />
                        </a>
                      ))}
                 </div>
            </div>
        </div>
      </div>

      <div className="border-t border-white/10 pt-6 flex flex-col gap-3 items-center text-center w-full">
        <div className="text-[clamp(0.75rem,0.9vw,1rem)] text-white">© {new Date().getFullYear()} Blue Pearl Industries. All rights reserved.</div>

        <div className="w-full pb-[30px] sm:pb-[50px] flex flex-col items-center">
          <Link to="/" className="w-full max-w-[100%] xl:max-w-[100%] mx-auto mb-4 block transition-opacity hover:opacity-80 px-[10px] xl:px-[70px]">
            <img
              ref={logoRef}
              src={Logo}
              alt="MAVIINCI"
              className="w-full h-auto object-contain"
            />
          </Link>
          <div className="relative mt-3 w-full max-w-[100%] xl:max-w-[100%] h-[2px] overflow-hidden px-[10px] xl:px-[70px]">
            <div className="absolute inset-0 mx-auto underline-bar" />
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterSection({ title, children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-white/10 pb-4 md:border-none md:pb-0">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between text-left md:pointer-events-none group outline-none"
      >
        <div className="text-[clamp(0.75rem,0.9vw,1rem)] uppercase tracking-[0.25em] text-white md:mb-4 font-heading font-bold">{title}</div>
        <span className="text-xl md:hidden text-[#D4AF37]">{open ? '−' : '+'}</span>
      </button>

      <div className={`overflow-hidden transition-all duration-300 md:block ${open ? 'max-h-60 mt-2' : 'max-h-0 md:max-h-none'}`}>
        {children}
      </div>
    </div>
  );
}
